import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { useTheme } from '../../../context/ThemeContext';
import { ReactComponent as ArrowIcon } from '../../../assets/arrowRight.svg';

const HistoryTile = () => {
  const { isDarkMode } = useTheme();
  return (
    <>
      <Wrapper>
        <Container>
          <Header>How it started vs. how it's going</Header>
          <HistoryContent>
            A short personal history as it relates to design and development,
            and how I've found value in the cross-section between both
            disciplines.
          </HistoryContent>
        </Container>
        <Footer>
          <NavLink to={`/history`} style={{ textDecoration: 'none' }}>
            <Button darkMode={isDarkMode}>
              <Icon />
              <ButtonText>Read More</ButtonText>
            </Button>
          </NavLink>
          <Date>01/18/2025</Date>
        </Footer>
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 40px 44px;
  justify-content: space-between;

  @media (max-width: 500px) {
    padding: 20px 22px;
    align-items: center;
    gap: 16px;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media (max-width: 500px) {
    gap: 16px;
  }
`;

const Header = styled.h1`
  font-size: calc(40 / 16 * 1rem);
  font-weight: 400;
  margin-bottom: 4px;
  line-height: 32px;
  font-family: 'Bashing';
`;

const HistoryContent = styled.p`
  font-size: 1rem;
  line-height: 26px;
  letter-spacing: 0.5px;
  font-weight: 400;
  display: flex;
  text-align: left;
`;

const Icon = styled(ArrowIcon)`
  transform: rotate(-45deg);
  color: ${({ theme }) => theme.text};
  height: 40px;
  width: 40px;
  margin-top: 6px;
`;

const Footer = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
`;

const Button = styled.button`
  height: 36px;
  padding: 0px 12px 0px 3px;
  top: 20px;
  right: 20px;
  border-radius: 18px;
  border: ${({ theme }) => theme.border};
  background: ${({ theme, darkMode }) =>
    darkMode ? theme.tileBackground : 'transparent'};
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const ButtonText = styled.p`
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.25px;
  font-weight: 400;
  color: ${({ theme }) => theme.text};
`;

const Date = styled.p`
  color: ${({ theme }) => theme.text};
  @media (max-width: 500px) {
    display: none;
  }
`;

export default HistoryTile;
